// Per-surface config for <ThemeEditor>. Keeps the editor declarative: which
// token sections render, and whether Match-Gallery checkboxes are offered.
// 'linkvault' uses the LEGACY {bg_color,wallpaper,accent} shape (byte-identical
// to today); 'gallery'/'business_box' use the generalized token shape.
export const RESOURCE_TYPES = {
  LINKVAULT: "linkvault",
  GALLERY: "gallery",
  BUSINESS_BOX: "business_box",
};

export const THEME_CONFIG = {
  linkvault: {
    shape: "legacy", // {bg_color, wallpaper, accent, preset}
    sections: ["bg_color", "wallpaper", "accent"],
    matchGallery: true,
    matchTokens: ["surface", "button", "card"], // LinkVault has no rounding token of its own today
  },
  gallery: {
    shape: "tokens", // {background, button, card, surface, corner_rounding}
    sections: ["background", "surface", "button", "card", "corner_rounding"],
    matchGallery: false, // Gallery is the reference surface — never matches
  },
  business_box: {
    shape: "tokens",
    sections: ["background", "surface", "button", "card", "corner_rounding"],
    matchGallery: true,
    matchTokens: ["corner_rounding", "surface", "button", "card"],
  },
};

export const getThemeConfig = (resourceType) =>
  THEME_CONFIG[resourceType] || THEME_CONFIG.linkvault;
